module.exports = __webpack_public_path__ + "static/AngelaHe4-509a5914f0c4f5092ff1e35eb26f0d6a.png";